export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

export const DESKTOP_BREAKPOINT_QUERY = getMinWidthMediaQuery(BREAKPOINTS.lg);

export type BreakpointName = keyof typeof BREAKPOINTS;

export function resolveBreakpointMinWidth(breakpoint: BreakpointName | number) {
  return typeof breakpoint === 'number' ? breakpoint : BREAKPOINTS[breakpoint];
}

export function getMinWidthMediaQuery(breakpoint: BreakpointName | number) {
  return `(min-width: ${resolveBreakpointMinWidth(breakpoint)}px)`;
}

export function getMediaQueryMatch(query: string) {
  if (
    typeof window === 'undefined' ||
    typeof window.matchMedia !== 'function'
  ) {
    return false;
  }

  return window.matchMedia(query).matches;
}
